export const USER_DETAIL_CATEGORIES = [
  {
    id: 1,
    name: 'Full Name'
  },
  {
    id: 2,
    name: 'Email Address'
  },
  {
    id: 3,
    name: 'Mobile Number'
  },
  {
    id: 4,
    name: 'Car Plate Number'
  },
  {
    id: 5,
    name: 'Car model'
  }
]

export const AGREEMENTS_CATEGORIES = [
  {
    id: 10,
    name: 'Privacy Policy'
  },
  {
    id: 20,
    name: 'Terms and Instructions'
  },
  {
    id: 30,
    name: 'Non-disclosure'
  }
]

export const USE_YEYPASS = [
  {
    id: 1,
    name: 'use-yeypass',
    value: 'Hotel'
  },
  {
    id: 2,
    name: 'use-yeypass',
    value: 'Condo'
  },
  {
    id: 3,
    name: 'use-yeypass',
    value: 'Company Office'
  },
  {
    id: 4,
    name: 'use-yeypass',
    value: 'Building Premises'
  },
  {
    id: 5,
    name: 'use-yeypass',
    value: 'Co-working Space'
  },
  {
    id: 6,
    name: 'use-yeypass',
    value: 'School'
  }
]



// WEBPACK FOOTER //
// ./src/api/constants/Business.js